import React, { useEffect, useRef, useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { Accordion, AccordionTab } from "primereact/accordion";
import "./INTERIOR_DESIGN_TEMPLATE.css";
import "../../CRM/Leads/Leads.css";
import { Api } from "../../../services/api";
import { useFormik } from "formik";
import { useNavigate } from "react-router-dom";
import { classNames } from "primereact/utils";

import { InteriorDesignTemplate } from "../../../services/Template/interior-design-template";
import { Toast } from "primereact/toast";
import { Button } from "primereact/button";
import { useParams } from 'react-router-dom';
import { FaCopy, FaPlus, FaTrash, FaFilePdf, FaSave } from 'react-icons/fa';
// import { useScreenshot } from 'use-react-screenshot'
// import html2canvas from 'html2canvas';
import { toPng } from 'html-to-image';
import jsPDF from 'jspdf';
import { InputNumber } from "primereact/inputnumber";
import { InputTextarea } from "primereact/inputtextarea";
import { InputText } from "primereact/inputtext";
import { BsFillInfoCircleFill } from "react-icons/bs";
import InteriorDesignPreview from "./InteriorDesignPreview";

const EDIT_INTERIOR_DESIGN_TEMPLATE = ({ pmId }) => {
  const [isLoading, setIsLoading] = useState(true);
  const [isCopyBtnLoading, setIsCopyBtnLoading] = useState(false);
  const [isPdfBtnLoading, setIsPdfBtnLoading] = useState(false);
  const [isSaveBtnLoading, setIsSaveBtnLoading] = useState(false);
  const [showInteriorPreview, setShowInteriorPreview] = useState(false);
  const [previewValues, setPreviewValues] = useState(null);
  const [projectName, setProjectName] = useState("");
  const [accordionActiveIndex, setAccordionActiveIndex] = useState([0, 1, 2, 3]);

  const ref = useRef(null)
  const ref2 = useRef(null)
  const containerRef = useRef(null);

  const [projectData, setProjectData] = useState([]);
  const navigate = useNavigate();
  const { editId } = useParams();
  const toast = useRef(null);

  const adjustTextareaHeight = (textarea) => {
    textarea.style.height = 'auto'; // Reset the height
    textarea.style.height = textarea.scrollHeight + 'px'; // Set the height to the scroll height
  };

  const expandAllTextareas = () => {
    elementRefs.forEach(ref => {
      if (ref.current) {
        const textareas = ref.current.querySelectorAll('textarea');
        textareas.forEach(adjustTextareaHeight);
      }
    });
  };

  const formik = useFormik({
    initialValues: InteriorDesignTemplate.getFormName(),
    validate: (data) => {

    },

    onSubmit: (data) => {
      if (!existPageWithoutSave) {
        return;

      }
      setIsSaveBtnLoading(true);

      const token = localStorage.getItem('authToken');

      // Create headers with token if it exists
      const headers = {
        'Content-Type': 'application/json',
        'Authorization': token ? `Bearer ${token}` : ''
      };

      data.user_id = localStorage.getItem('user_id');
      data.role_id = localStorage.getItem('role_id');
      var url = Api.API_BASE_URL + 'interior/save';



      // var url = Api.API_BASE_URL + 'interior-template/update/' + editId;


      fetch(url, {
        method: "POST",
        headers: headers,
        body: JSON.stringify(data),
      })
        .then((response) => response.json())
        .then((Josn) => {
          setIsSaveBtnLoading(false);
          setExistPageWithoutSave(false);
          if (Josn.error != '') {
            toast.current.show({ severity: 'error', summary: 'Error', detail: Josn.error });

          } else {
            toast.current.show({ severity: 'success', summary: 'Success', detail: Josn.result });
          }

        })
        .catch((error) => {
          setIsSaveBtnLoading(false);
          console.error("Error:", error);
        });



    }
  });

  const [existPageWithoutSave, setExistPageWithoutSave] = useState(false);

  useEffect(() => {

    getDetailsInterioDesign(pmId);

    return () => {
      // Cleanup tasks before the component is unmounted
      // if (existPageWithoutSave) {
      // if (window.confirm('Do you want to save changes you made to this document?')) {
      formik.handleSubmit();
      // }
      // }
    };
  }, [pmId,]);

  const [preConstructionShedule, setPreConstructionShedule] = useState([1]);
  const handleAddInputForPreConstructionShedule = () => {
    setPreConstructionShedule([...preConstructionShedule, 1]);
    var t = {
      genrealProjectCheckListTitle: "",
      misc1: "",
      miscReason: '',
    };
    formik.values.section_10.push(t);

  };

  const handleDeleteInputForreConstructionShedule = (index) => {
    setPreConstructionShedule([...preConstructionShedule, 2]);
    var newArray = [...preConstructionShedule];
    newArray.splice(index, 1);
    formik.values.section_10.splice(index, 1);
    setPreConstructionShedule(newArray);
  };

  const getDetailsInterioDesign = (id) => {
    // interior-template/get-interior/{editId}
    formik.setFieldValue('project_id', id);
    var _body = {
      projectId: id,
    }
    const token = localStorage.getItem('authToken');

    // Create headers with token if it exists
    const headers = {
      'Content-Type': 'application/json',
      'Authorization': token ? `Bearer ${token}` : ''
    };
    fetch(Api.API_BASE_URL + 'interior/get', {
      method: "POST",
      headers: headers,

      body: JSON.stringify(_body),
    })
      .then((response) => response.json())
      .then((response) => {
        // setIsLoading(false);

        if (response.error != '') {

          formik.setFieldValue('interior_id', 0);
        } else {
          formik.setFieldValue('project_id', response.project_id);
          formik.setFieldValue('interior_id', response.interior_id);
          InteriorDesignTemplate.section_1_List().forEach(element => {
            formik.setFieldValue(element, response.sec_1[element]);
          });

          InteriorDesignTemplate.section_2_List().forEach(element => {
            formik.setFieldValue(element, response.sec_2[element]);
          }); InteriorDesignTemplate.section_3_List().forEach(element => {
            formik.setFieldValue(element, response.sec_3[element]);
          });



          if (response.sec_4.length != 0) {
            const templateSec4 = InteriorDesignTemplate.getFormName().section_4;
            const savedMap4 = {};
            response.sec_4.forEach(item => { if (item && item.selection) savedMap4[item.selection] = item; });
            const mergedSec4 = templateSec4.map(tmpl => savedMap4[tmpl.selection] !== undefined ? savedMap4[tmpl.selection] : tmpl);
            formik.setFieldValue(`section_4`, mergedSec4);
          }
          if (response.sec_5.length != 0) {
            const templateSec5 = InteriorDesignTemplate.getFormName().section_5;
            const savedMap5 = {};
            response.sec_5.forEach(item => { if (item && item.selection) savedMap5[item.selection] = item; });
            const mergedSec5 = templateSec5.map(tmpl => savedMap5[tmpl.selection] !== undefined ? savedMap5[tmpl.selection] : tmpl);
            formik.setFieldValue(`section_5`, mergedSec5);
          }
          if (response.sec_6.length != 0) {
            formik.setFieldValue(`section_6`, response.sec_6);
          }
          if (response.sec_7.length != 0) {
            formik.setFieldValue(`section_7`, response.sec_7);
          }
          if (response.sec_8.length != 0) {
            formik.setFieldValue(`section_8`, response.sec_8);
          }



          if (response.sec_9.length != 0) {
            formik.setFieldValue(`section_9`, response.sec_9);
          }
          if (response.sec_10.length != 0) {
            formik.setFieldValue(`section_10`, response.sec_10);
            var t = [];
            response.sec_10.forEach(element => {
              t.push(0)
            });
            setPreConstructionShedule(t);
          }


          formik.setFieldValue('project_id', response.project_id);
          formik.setFieldValue('interior_id', response.interior_id);
          if (response.project_name) setProjectName(response.project_name);

        }

        setIsLoading(false);

      })
      .catch((error) => {
        console.error("Error:", error);
        setIsLoading(false);
      });
  }



  //? ________________________________

  const headerStyle = {
    background: "#FEC025",
    border: "1px solid #E9ECEF",
    textAlign: "center",
  };

  const cellStyle = {
    border: "1px solid #E9ECEF",
    borderLeft: "2px solid #E9ECEF",
    // textAlign: 'center',
  };

  const cellStyleW = {
    border: "1px solid #E9ECEF",
    borderLeft: "2px solid #E9ECEF",
    backgroundColor: 'white',
    paddingTop: '5px'
  };

  const yesCellStyle = {
    ...cellStyleW,
    // background: "#FEC025",
  };



  const firstColumnWidth = {
    width: "80px", // Adjust the width as needed
  };

  const dropdownCellStyle = {
    ...yesCellStyle,
    padding: "0",
    // Remove padding to fit the dropdown
  };

  //? --------------------------------------

  //! ________________________________
  const renderTextArea = (fieldName, placeholder, formdata = '', maxLine = 2) => (
    <InputTextarea
      placeholder={placeholder}
      name={fieldName}
      id={fieldName}
      autoResize
      rows={maxLine}
      className="w-full text-center p-2 mb-0"
      value={formdata !== '' ? formdata : formik.values[fieldName]}
      onChange={(e) => {
        setExistPageWithoutSave(true);
        console.log(e.target.value)
        formik.setFieldValue(fieldName, e.target.value)
      }}
      onKeyDown={(e) => {
        if (e.key === 'Enter') {
          // e.preventDefault(); // Prevent form submission on Enter key press
        }
      }}
      style={{ width: '100%', boxSizing: 'border-box', border: 'none', outline: 'none',  color: '#495057', display: 'flex', alignItems: 'center', paddingTop: '8px' }}
    />
  );

  const renderTextAreaFull = (fieldName, placeholder, formData = '', maxLine = 2,) => (
    <InputTextarea
      placeholder={placeholder}
      name={fieldName}
      autoResize
      id={fieldName}
      rows={maxLine}
      className="w-full text-center p-2 mb-0"
      value={formData !== '' ? formData : formik.values[fieldName]}
      onChange={(e) => {
        console.log(e.target.value)
        setExistPageWithoutSave(true);
        formik.setFieldValue(fieldName, e.target.value)
      }}
      style={{ width: '100%', boxSizing: 'border-box', border: 'none', outline: 'none',  color: '#495057', display: 'flex', alignItems: 'center', paddingTop: '8px', }}
    />
  );

  const renderInputArea = (fieldName, placeholder, type = 'text', formdata = '') => {
    let value = formdata !== '' ? formdata : formik.values[fieldName];
    if (type == 'date') {

      if (value != null) {
        let timestamp = new Date(value);

        if (!isNaN(timestamp.getTime())) {
          value = timestamp.toISOString().split('T')[0];
        }
      }
    }
    return (
      <InputText
        type={type}
        placeholder={placeholder}
        name={fieldName}
        id={fieldName}
        value={value}
         className="w-full text-center p-2 mb-0"
        // onChange={(e) => { formik.setFieldValue(fieldName, e.target.value) }}
        onChange={(e) => {
          setExistPageWithoutSave(true);
          formik.setFieldValue(fieldName, e.target.value)
        }}
        onKeyDown={(e) => {
          if (e.key === 'Enter') {
            e.preventDefault(); // Prevent form submission on Enter key press
          }
        }}
        style={{
          width: '100%',
          height: '40px',
          boxSizing: 'border-box',
          border: 'none',
          textAlign: 'center',
          marginTop: '0px',
        }}
      />
    );
  }

  const renderInputAreaForAmount = (fieldName, formData = '') => (
    <InputNumber
      inputId="currency-us"
      value={formData != '' ? formData : formik.values[fieldName]}
      // value={formdata !== '' ? formdata : formik.values[fieldName]}
      className="text-center"
      inputClassName={formik.values[fieldName] < 0 ? "is-negative" : "is-positive"}
      placeholder="$0.00"
      onChange={(e) => {
        setExistPageWithoutSave(true);
        formik.setFieldValue(fieldName, e.value)
      }}
      mode="currency"
      currency="USD"
      locale="en-US"
      onKeyDown={(e) => {
        if (e.key === "Enter") {
          e.preventDefault(); // Prevent form submission on Enter key press
        }
      }}
      style={{
        width: "100%",
        height: "40px",
        boxSizing: "border-box",
        border: "none",
        textAlign: "center !important",
        marginTop: "0px",
        outline: 'none',
      }}
    />
  );

  const renderPercentageInputArea = (fieldName, formData = '') => (
    <InputNumber

      value={formData != '' ? formData : formik.values[fieldName]}
      className="text-center"
      inputClassName={Number(formik.values[fieldName]) < 0 ? "is-negative" : "is-positive"}
      placeholder="0.00"
      maxFractionDigits={2}
      onChange={(e) => {
        setExistPageWithoutSave(true);
        formik.setFieldValue(fieldName, e.value)
      }}
      suffix="%"
      onKeyDown={(e) => {
        if (e.key === "Enter") {
          e.preventDefault(); // Prevent form submission on Enter key press
        }
      }}
      style={{
        width: "100%",
        height: "40px",
        boxSizing: "border-box",
        border: "none",
        textAlign: "center !important",
        marginTop: "0px",
      }}
    />
  );

  const renderSelect = (fieldName, formdata = '') => {
    var val = (formdata != '') ? formdata : formik.values[fieldName];
    console.log('val', val);

    return <select
      name={fieldName}
      id={fieldName}
      value={formdata !== '' ? formdata : formik.values[fieldName]}
      className={'select-text-color-' + val}
      onChange={(e) => {
        setExistPageWithoutSave(true);
        formik.setFieldValue(fieldName, e.target.value);
      }}
      style={{ width: '100%', textAlign: 'center',  color: 'white', backgroundColor: '#ff0000', border: 'none', height: '40px' }}
    >
      <option value="N">No</option>
      <option value="Y">Yes</option>
      <option value="NA">N/A</option>
    </select>

  };


  const renderSelect1 = (fieldName, formdata = '') => {


    return (
      <select
        name={fieldName}
        id={fieldName}
        value={formdata !== '' ? formdata : formik.values[fieldName]}
        className={'select-text-color-' + formik.values[fieldName]}
        onChange={(e) => {
          setExistPageWithoutSave(true);
          formik.setFieldValue(fieldName, e.target.value);
        }}
        style={{ width: '100%', textAlign: 'center', color: 'white', backgroundColor: '#ff0000', border: 'none', height: '40px' }}
      >
        <option value="N">No</option>
        <option value="Y">Yes</option>
        {/* <option value="NA">NA</option> */}
      </select>
    );
  };





  //! -----------------------------------------------

  //? ------------------------------------------------
  const section_1_body = (title, fieldName_1, fieldName_2, fieldName_3, fieldName_4, fieldName_5) => {
    // renderInputArea
    return (
      <tr>
        <td style={{ ...cellStyle, minWidth: "250px" }}>{title}</td>

        {/* <td style={{ ...cellStyleW, minWidth: "150px" }}>{renderInputAreaForAmount(fieldName_1, '', 'number')}</td> */}
        {title === 'GP%:' ? null : (
        <td style={{ ...cellStyleW, minWidth: "150px" }}>
          {renderInputAreaForAmount(fieldName_1, '', 'number')}
        </td>
      )}
        <td style={{ ...cellStyleW, minWidth: "250px" }}>{renderTextAreaFull(fieldName_2, '',)}</td>
        <td style={{ ...cellStyleW, minWidth: "150px" }}>{renderPercentageInputArea(fieldName_3, '', 'number')}</td>

        <td style={{ ...cellStyleW, minWidth: "150px" }}>{renderTextAreaFull(fieldName_4, '',)}</td>
        <td style={{ ...cellStyleW, minWidth: "150px" }}>{renderTextAreaFull(fieldName_5, '',)}</td>
      </tr>
    );
  }

  const section_2_body = (title, fieldName_1, fieldName_2, fieldName_3, fieldName_4, fieldName_5) => {
    // renderInputArea
    return (
      <tr>
        <td style={{ ...cellStyle, minWidth: "300px" }}>{title}</td>

        <td style={{ ...dropdownCellStyle, width: '100px', height: '40px', }}>
          {renderSelect1(fieldName_1)}
        </td>
        <td style={{ ...cellStyleW, minWidth: "350px" }}>{renderTextAreaFull(fieldName_2, '',)}</td>
        <td style={{ ...cellStyleW, minWidth: "150px" }}>{renderInputArea(fieldName_3, '', 'number')}</td>

        <td style={{ ...cellStyleW, minWidth: "150px" }}>{renderTextAreaFull(fieldName_4, '', '')}</td>
        <td style={{ ...cellStyleW, minWidth: "150px" }}>{renderTextAreaFull(fieldName_5, '', '')}</td>
      </tr>
    );
  }


  //? ------------------------------------------------

  const copyImageToClipboard = (blob) => {
    // Check if Clipboard API is available
    if (navigator.clipboard && navigator.clipboard.write) {
      navigator.clipboard.write([
        new ClipboardItem({
          [blob.type]: blob
        })
      ]).then(() => {
        setIsCopyBtnLoading(false);
        toast.current.show({ severity: 'success', summary: 'Success', detail: 'Image copied to clipboard' });
        console.log('Image copied to clipboard');
      }).catch((error) => {
        setIsCopyBtnLoading(false);
        toast.current.show({ severity: 'error', summary: 'Error', detail: 'Error copying image to clipboard' });
        console.error('Error copying image to clipboard:', error);
      });
    } else {
      setIsCopyBtnLoading(false);
      console.error('Clipboard API not available');
    }
  };
  const elementRefs = [
    useRef(null),
  ];



  const takeScreenshotAndCopy = async () => {
    setIsCopyBtnLoading(true);
    console.log('Take screenshot and copy to clipboard');

    try {
      expandAllTextareas();

      const canvasPromises = elementRefs.map(async (ref) => {
        if (ref.current) {
          return await toPng(ref.current, {
            cacheBust: true,
            pixelRatio: 2,
          });
        }
        return null;
      });

      const images = await Promise.all(canvasPromises);

      // Create a new canvas to combine screenshots
      const combinedCanvas = document.createElement('canvas');
      const context = combinedCanvas.getContext('2d');

      // Calculate total height of combined screenshots
      let totalHeight = 0;
      let maxWidth = 0;
      for (const imgSrc of images) {
        if (!imgSrc) continue; 
        const img = new Image();
        img.src = imgSrc;
        await new Promise((resolve) => {
          img.onload = () => {
            totalHeight += img.height;
            if (img.width > maxWidth) maxWidth = img.width;
            resolve();
          };
          img.onerror = () => {
             resolve();
          }
        });
      }

      combinedCanvas.width = maxWidth;
      combinedCanvas.height = totalHeight;

      let offsetY = 0;
      for (const imgSrc of images) {
         if (!imgSrc) continue; 
        const img = new Image();
        img.src = imgSrc;
        await new Promise((resolve) => {
          img.onload = () => {
            context.drawImage(img, 0, offsetY);
            offsetY += img.height;
            resolve();
          };
          img.onerror = () => {
             resolve();
          }
        });
      }

      // Convert the combined canvas to a data URL
      combinedCanvas.toBlob(blob => {
        if (blob) {
          copyImageToClipboard(blob);
        } else {
          console.error('Error creating blob');
          setIsCopyBtnLoading(false);
          if (toast.current) {
            toast.current.show({ severity: 'error', summary: 'Error', detail: 'Failed to create image blob' });
          }
        }
      }, 'image/png');

    } catch (error) {
      setIsCopyBtnLoading(false);
      console.error('Error taking screenshots:', error);
    }
  };

  const downloadPDF = async () => {
    setIsPdfBtnLoading(true);
    console.log('Download PDF');

    try {
      // Expand all textareas to fit their content
      expandAllTextareas();

      const canvasPromises = elementRefs.map(async (ref) => {
        if (ref.current) {
          return await toPng(ref.current, {
            cacheBust: true,
            pixelRatio: 1.5, // Reduced from 2 to 1.5 to reduce file size
            backgroundColor: '#ffffff'
          });
        }
        return null;
      });

      const images = await Promise.all(canvasPromises);

      // Create a new canvas to combine screenshots
      const combinedCanvas = document.createElement('canvas');
      const context = combinedCanvas.getContext('2d');

      // Calculate total height and max width of combined screenshots
      let totalHeight = 0;
      let maxWidth = 0;
      for (const imgSrc of images) {
        if (!imgSrc) continue; 
        const img = new Image();
        img.src = imgSrc;
        await new Promise((resolve) => {
          img.onload = () => {
            totalHeight += img.height;
            if (img.width > maxWidth) maxWidth = img.width;
            resolve();
          };
        });
      }

      combinedCanvas.width = maxWidth;
      combinedCanvas.height = totalHeight;

      // Fill white background
      context.fillStyle = '#ffffff';
      context.fillRect(0, 0, combinedCanvas.width, combinedCanvas.height);

      let offsetY = 0;
      for (const imgSrc of images) {
        if (!imgSrc) continue;
        const img = new Image();
        img.src = imgSrc;
        await new Promise((resolve) => {
          img.onload = () => {
            context.drawImage(img, 0, offsetY);
            offsetY += img.height;
            resolve();
          };
        });
      }

      // Create PDF
      const pdf = new jsPDF('p', 'mm', 'a4');
      const pdfWidth = pdf.internal.pageSize.getWidth();   // 210mm
      const pdfHeight = pdf.internal.pageSize.getHeight(); // 297mm
      
      const totalCanvasWidth = combinedCanvas.width;
      const totalCanvasHeight = combinedCanvas.height;

      // Calculate how much canvas height fits on one PDF page
      // Relationship: pdfWidth (mm) == totalCanvasWidth (px)
      // Therefore: pdfHeight (mm) == pageCanvasHeight (px)
      const pageCanvasHeight = (pdfHeight * totalCanvasWidth) / pdfWidth; 

      let heightLeft = totalCanvasHeight;
      let currentY = 0;
      let pageIndex = 0;

      while (heightLeft > 0) {
        if (pageIndex > 0) {
          pdf.addPage();
        }

        // Determine height of the slice for this page
        const sliceHeight = Math.min(heightLeft, pageCanvasHeight);

        // Create a temporary canvas for the slice
        const pageCanvas = document.createElement('canvas');
        pageCanvas.width = totalCanvasWidth;
        pageCanvas.height = sliceHeight;
        
        const pageCtx = pageCanvas.getContext('2d');
        
        // Fill white background (good practice for JPEGs)
        pageCtx.fillStyle = '#ffffff';
        pageCtx.fillRect(0, 0, pageCanvas.width, pageCanvas.height);

        // Draw the specific slice from the combined canvas
        pageCtx.drawImage(
          combinedCanvas, 
          0, currentY, totalCanvasWidth, sliceHeight, // Source rectangle
          0, 0, totalCanvasWidth, sliceHeight         // Destination rectangle
        );

        // Convert slice to JPEG (much smaller than PNG)
        // 0.75 quality is usually indistinguishable for documents but much smaller
        const pageData = pageCanvas.toDataURL('image/jpeg', 0.75);

        // Calculate the height in PDF units for this slice
        // (Should be pdfHeight, unless it's the last incomplete page)
        const pdfSliceHeight = (sliceHeight * pdfWidth) / totalCanvasWidth;

        pdf.addImage(pageData, 'JPEG', 0, 0, pdfWidth, pdfSliceHeight);

        heightLeft -= sliceHeight;
        currentY += sliceHeight;
        pageIndex++;
      }
      
      const now = new Date();
      const options = {
        timeZone: 'America/Los_Angeles',
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        hour12: false
      };

      const formatter = new Intl.DateTimeFormat('en-US', options);
      const parts = formatter.formatToParts(now);
      const partValues = {};
      parts.forEach(p => partValues[p.type] = p.value);

      const timestamp = `${partValues.year}-${partValues.month}-${partValues.day}_${partValues.hour}-${partValues.minute}`;

      pdf.save(`Interior Design Playbook - Weekly Update - ${timestamp}.pdf`);

    } catch (error) {
      console.error('Error generating PDF:', error);
      if (toast.current) {
          toast.current.show({ severity: 'error', summary: 'Error', detail: 'Failed to generate PDF' });
      }
    } finally {
      setIsPdfBtnLoading(false);
    }
  };

  //* -------------------------


  return (
    <div className="dm-template-container">
      <Toast ref={toast} />
      <InteriorDesignPreview
        visible={showInteriorPreview}
        onHide={() => setShowInteriorPreview(false)}
        values={previewValues}
        projectName={projectName}
      />
      {isLoading ? (
        <div className="dm-loading">
          Loading...
          <div className="dm-spinner"></div>
        </div>
      ) : (
        <form ref={containerRef} onSubmit={formik.handleSubmit} style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
            <div className="dm-template-card">
              <div className="dm-template-header" style={{ display: 'flex', justifyContent: 'flex-end' }}>
                <div className="dm-header-actions">
                  <Button className="dm-btn-copy" icon={<FaCopy />} label="Preview Weekly Update" type="button" onClick={() => { setPreviewValues(formik.values); setShowInteriorPreview(true); }} />
                  <Button type="submit" className="dm-btn-save" icon={<FaSave />} label="SAVE" loading={isSaveBtnLoading} />
                </div>
              </div>
              <div className="dm-template-body" style={{ flexGrow: 1 }}>
            <Accordion multiple activeIndex={accordionActiveIndex} onTabChange={(e) => setAccordionActiveIndex(e.index)}>

              <AccordionTab header="ACTION STEPS">
                <div className="table-container" style={{ overflowX: "auto" }}>
                  <table style={{ borderCollapse: "collapse", }}>
                    <thead>
                      <tr>
                        <th style={{ ...headerStyle, width: "300px" }} >
                          Action Steps
                        </th>
                        <th style={{ ...headerStyle, minWidth: "250px" }} colSpan={3} >
                          Address:
                        </th>
                        <th style={{ ...headerStyle, minWidth: "auto", }} rowSpan={2}  >
                          Interior Designer Comments
                        </th>
                        <th style={{ ...headerStyle, minWidth: "auto" }} rowSpan={2} >
                          Vp Construction Ops Comments Only
                        </th>
                      </tr>
                      <tr>
                        <th style={{ ...headerStyle, }} >
                        </th>
                        <th style={{ ...headerStyle, }} >
                          Total
                        </th>
                        <th style={{ ...headerStyle, }} >
                          Comments
                        </th>
                        <th style={{ ...headerStyle, }} >
                          % Complete
                        </th>
                      </tr>
                    </thead>

                    <tbody>
                      {section_1_body('ID Contract Amount:', 'IDContractAmountTotal', 'IDContractAmountComments', 'IDContractAmountPerComplete', 'IDContractAmountInterior', 'IDContractAmountVPC')}
                      {section_1_body('Amount Used:', 'AmountUsedTotal', 'AmountUsedComments', 'AmountUsedPerComplete', 'AmountUsedinterior', 'AmountUsedVPC')}
                      {section_1_body('GP%:', 'GpPerTotal', 'GpPerComments', 'GpPerComplete', 'GpPerInterior', 'GpPerVPC')}
                    </tbody>
                  </table>
                </div>

              </AccordionTab>

              <AccordionTab header="DELIVERABLES" className="mt-2">

                <div className="table-container" style={{ overflowX: "auto" }}>
                  <table style={{ borderCollapse: "collapse", }}>
                    <thead>

                      <tr>
                        <th style={{ ...headerStyle, width: "300px", }} >
                          Deliverables
                        </th>

                        <th style={{ ...headerStyle, width: "100px", }} >
                          Complete Yes/No
                        </th>
                        <th style={{ ...headerStyle, minWidth: "auto" }} >
                          Comments
                        </th>
                        <th style={{ ...headerStyle, minWidth: "auto" }} >
                        </th>
                        <th style={{ ...headerStyle, minWidth: "auto" }} >
                          Interior Designer Comments
                        </th>
                        <th style={{ ...headerStyle, minWidth: "auto" }} >
                          Vp Construction Ops Comments
                        </th>
                      </tr>
                    </thead>

                    <tbody>
                      {section_2_body('Project Preference Sheet Complete', 'ProjectPreferenceComplete', 'ProjectPreferenceComments', 'ProjectPreferencePerComplete', 'ProjectPreferenceInterior', 'ProjectPreferenceVPC')}

                      {section_2_body('RFI\'s up to Date?', 'RFIComplete', 'RFIComments', 'RFIPerComplete', 'RFIInterior', 'RFIVPC')}

                      {section_2_body('Drawings up to date?', 'DrawingsComplete', 'DrawingsComments', 'DrawingsPerComplete', 'Drawingsinterior', 'DrawingsVPC')}

                      {section_2_body('Selection Choices up to date?', 'SelectionsComplete', 'SelectionsComments', 'SelectionsPerComplete', 'SelectionsInterior', 'SelectionsVPC')}

                      {section_2_body('Floor Plans (Concept) - Reno Only', 'FLoorPlanComplete', 'FLoorPlanComments', 'FLoorPlanPerComplete', 'FLoorPlanInterior', 'FLoorPlanVPC')}

                    </tbody>
                  </table>
                </div>

              </AccordionTab>

              <AccordionTab header=" WEEKLY INTERIOR DESIGN UPDATE" className="mt-2">

                <div className="table-container" style={{ overflowX: "auto" }} ref={elementRefs[0]}>

                  <table style={{ borderCollapse: "collapse" }}>

                    <thead>

                      <tr>
                        <th style={{ ...headerStyle, minWidth: "auto", }} >
                          Weekly Interior Design Update
                        </th>

                        <th style={{ ...headerStyle, minWidth: "auto" }} >
                          Vp Construction Ops Comments
                        </th>
                      </tr>

                    </thead>

                    <tbody>
                      <tr>
                        <td style={{ minWidth: '50vw', display: 'flex', alignItems: 'center',  }}>
                              <td style={{ width: '100px' }}>Dear:  </td>
                          {renderTextArea('dear', '',)}

                        </td>

                        <td style={{ ...cellStyleW, minWidth: "530px", }} rowSpan={3}>
                          {renderTextAreaFull('dearVPCComments', '', '', 6)}
                        </td>

                      </tr>
                      <tr>
                        <td style={{ textAlign: 'center', verticalAlign: 'middle', paddingTop: '15px', paddingBottom: '10px', fontWeight: 'bold' }}>
                          Here Is Your Weekly Summary:
                          <sup> <BsFillInfoCircleFill size={12} className='text-gray-500 hover:text-gray-900' title='The date is updated automatically every week when it is archived.' /></sup>
                        </td>
                      </tr>
                      <tr>
                        <td style={{ display: 'flex', alignItems: 'center' }}>
                          <div style={{ width: '25%', marginRight: '15px' }}>
                          </div>
                          <div style={{ width: '25%', marginRight: '15px' }}>
                            <div style={{ textAlign: 'center', marginBottom: '5px' }}>From</div>
                            <InputText
                              type="date"
                              name="summaryFrom"
                              id="summaryFrom"
                              className="w-full text-center p-2 mb-0"
                              // value={formik.values['summaryFrom']}
                              value={formik.values.summaryFrom == null ? formik.values.summaryFrom : !isNaN(new Date(formik.values.summaryFrom).getTime()) ? new Date(formik.values.summaryFrom).toISOString().split('T')[0] : formik.values.summaryFrom
                              }
                              onChange={(e) => formik.setFieldValue('summaryFrom', e.target.value)}
                              style={{ width: '100%', textAlign: 'center', height: '40px', color: '#495057', }}

                            />
                          </div>
                          <div style={{ width: '25%', marginRight: '15px' }}>
                            <div style={{ textAlign: 'center', marginBottom: '5px' }}>To:</div>
                            <InputText
                              type="date"
                              name="summaryTo"
                              id="summaryTo"
                              className="w-full text-center p-2 mb-0"
                              // value={formik.values['summaryTo']}
                              value={formik.values.summaryTo == null ? formik.values.summaryTo : !isNaN(new Date(formik.values.summaryTo).getTime()) ? new Date(formik.values.summaryTo).toISOString().split('T')[0] : formik.values.summaryTo
                              }
                              onChange={(e) => formik.setFieldValue('summaryTo', e.target.value)}
                              style={{ width: '100%', textAlign: 'center',  height: '40px', color: '#495057', }}
                            />
                          </div>

                        </td>
                      </tr>
                    </tbody>
                  </table>


                  <table style={{ borderCollapse: "collapse", marginTop: '20px' }}>
                    <thead>
                      <tr>
                        <th style={{ ...headerStyle, width: "300px", }} >
                          ID Documents
                        </th>
                        <th style={{ ...headerStyle, minWidth: "auto" }} >
                          Area
                        </th>
                        <th style={{ ...headerStyle, minWidth: "auto" }} >
                          Selections
                        </th>
                        <th style={{ ...headerStyle, width: "100px" }} >
                          Completed Yes/No/NA
                        </th>
                        <th style={{ ...headerStyle, minWidth: "auto" }} >
                          Interior Designer Comments
                        </th>
                        <th style={{ ...headerStyle, width: "100px" }} >
                          ID Bid Req
                        </th>
                        <th style={{ ...headerStyle, width: "100px" }} >
                          PO
                        </th>
                        <th style={{ ...headerStyle, minWidth: "auto" }} >
                          PO or Drawing Due Date
                        </th>
                        <th style={{ ...headerStyle, minWidth: "auto" }} >
                          Vp Construction Ops Comments
                        </th>


                      </tr>
                    </thead>

                    <tbody>

                      {InteriorDesignTemplate.getFormName().section_4.map((item, index) => {
                        return (
                          index == 0 ? (<tr>
                            <td style={{ ...cellStyle, textAlign: 'center', fontWeight: '600' }} rowSpan={10}> Pre Start</td>
                            <td style={{ ...cellStyle }} rowSpan={10} >  </td>
                            <td style={{ ...cellStyle }} > {item.selection} </td>
                            <td style={{ ...dropdownCellStyle, width: "100px", height: '40px', }}>  {renderSelect(`section_4.${index}.completed`, formik.values.section_4[index].completed)} </td>
                            <td style={{ ...cellStyleW, }}>  {renderTextAreaFull(`section_4.${index}.interiorDesignerComments`, ' ', formik.values.section_4[index].interiorDesignerComments)} </td>
                            <td style={{ ...dropdownCellStyle, minWidth: '100px', height: '40px', }}>  {renderSelect(`section_4.${index}.idBidReq`, formik.values.section_4[index].idBidReq)} </td>
                            <td style={{ ...dropdownCellStyle, width: "100px", height: '40px', }}> {renderSelect(`section_4.${index}.pO`, formik.values.section_4[index].pO)} </td>
                            <td style={{ ...cellStyleW, }}> {renderInputArea(`section_4.${index}.poOrDDue`, '', 'date', formik.values.section_4[index].poOrDDue)} </td>
                            <td style={{ ...cellStyleW, }}>  {renderTextAreaFull(`section_4.${index}.vPSComments`, ' ', formik.values.section_4[index].vPSComments)} </td>
                          </tr>) : (
                            <tr>

                              <td style={{ ...cellStyle }} > {item.selection} </td>
                              <td style={{ ...dropdownCellStyle, width: "100px", height: '40px', }}>  {renderSelect(`section_4.${index}.completed`, formik.values.section_4[index].completed)} </td>
                              <td style={{ ...cellStyleW, }}>  {renderTextAreaFull(`section_4.${index}.interiorDesignerComments`, '', formik.values.section_4[index].interiorDesignerComments)} </td>
                              <td style={{ ...dropdownCellStyle, width: "100px", height: '40px', }}>  {renderSelect(`section_4.${index}.idBidReq`, formik.values.section_4[index].idBidReq)} </td>
                              <td style={{ ...dropdownCellStyle, width: "100px", height: '40px', }}> {renderSelect(`section_4.${index}.pO`, formik.values.section_4[index].pO)} </td>
                              <td style={{ ...cellStyleW, }}> {renderInputArea(`section_4.${index}.poOrDDue`, '', 'date', formik.values.section_4[index].poOrDDue)} </td>
                              <td style={{ ...cellStyleW, }}>  {renderTextAreaFull(`section_4.${index}.vPSComments`, '', formik.values.section_4[index].vPSComments)} </td>
                            </tr>
                          )
                        )
                      })

                      }
                      {/* SCHEDULES  EXTERIOR  Start */}
                      {InteriorDesignTemplate.getFormName().section_5.map((item, index) => {
                        return (
                          index == 0 ? (<tr>
                            <td style={{ ...cellStyle, textAlign: 'center', fontWeight: '600' }} rowSpan={14}> Schedules</td>
                            <td style={{ ...cellStyle }} rowSpan={4} > EXTERIOR  </td>
                            <td style={{ ...cellStyle }} > {item.selection} </td>
                            <td style={{ ...dropdownCellStyle, width: "100px", height: '40px', }}>  {renderSelect(`section_5.${index}.completed`, formik.values.section_5[index].completed)} </td>
                            <td style={{ ...cellStyleW, }}>  {renderTextAreaFull(`section_5.${index}.interiorDesignerComments`, '', formik.values.section_5[index].interiorDesignerComments)} </td>
                            <td style={{ ...dropdownCellStyle, width: "100px", height: '40px', }}>  {renderSelect(`section_5.${index}.idBidReq`, formik.values.section_5[index].idBidReq)} </td>
                            <td style={{ ...dropdownCellStyle, width: "100px", height: '40px', }}> {renderSelect(`section_5.${index}.pO`, formik.values.section_5[index].pO)} </td>
                            <td style={{ ...cellStyleW, }}> {renderInputArea(`section_5.${index}.poOrDDue`, '', 'date', formik.values.section_5[index].poOrDDue)} </td>
                            <td style={{ ...cellStyleW, }}>  {renderTextAreaFull(`section_5.${index}.vPSComments`, '', formik.values.section_5[index].vPSComments)} </td>

                          </tr>) : (
                            <tr>

                              <td style={{ ...cellStyle }} > {item.selection} </td>
                              <td style={{ ...dropdownCellStyle, width: "100px", height: '40px', }}>  {renderSelect(`section_5.${index}.completed`, formik.values.section_5[index].completed)} </td>
                              <td style={{ ...cellStyleW, }}>  {renderTextAreaFull(`section_5.${index}.interiorDesignerComments`, '', formik.values.section_5[index].interiorDesignerComments)} </td>
                              <td style={{ ...dropdownCellStyle, width: "100px", height: '40px', }}>  {renderSelect(`section_5.${index}.idBidReq`, formik.values.section_5[index].idBidReq)} </td>
                              <td style={{ ...dropdownCellStyle, width: "100px", height: '40px', }}> {renderSelect(`section_5.${index}.pO`, formik.values.section_5[index].pO)} </td>
                              <td style={{ ...cellStyleW, }}> {renderInputArea(`section_5.${index}.poOrDDue`, '', 'date', formik.values.section_5[index].poOrDDue)} </td>
                              <td style={{ ...cellStyleW, }}>  {renderTextAreaFull(`section_5.${index}.vPSComments`, '', formik.values.section_5[index].vPSComments)} </td>

                            </tr>
                          )
                        )
                      })

                      }

                      {/* SCHEDULES  EXTERIOR  End */}
                      {/* SCHEDULES  INTERIOR  start */}
                      {InteriorDesignTemplate.getFormName().section_6.map((item, index) => {
                        return (
                          index == 0 ? (<tr>

                            <td style={{ ...cellStyle }} rowSpan={11} > INTERIOR  </td>
                            <td style={{ ...cellStyle }} > {item.selection} </td>
                            <td style={{ ...dropdownCellStyle, width: "100px", height: '40px', }}>  {renderSelect(`section_6.${index}.completed`, formik.values.section_6[index].completed)} </td>
                            <td style={{ ...cellStyleW, }}>  {renderTextAreaFull(`section_6.${index}.interiorDesignerComments`, '', formik.values.section_6[index].interiorDesignerComments)} </td>
                            <td style={{ ...dropdownCellStyle, width: "100px", height: '40px', }}>  {renderSelect(`section_6.${index}.idBidReq`, formik.values.section_6[index].idBidReq)} </td>
                            <td style={{ ...dropdownCellStyle, width: "100px", height: '40px', }}>  {renderSelect(`section_6.${index}.pO`, formik.values.section_6[index].pO)} </td>
                            <td style={{ ...cellStyleW, }}> {renderInputArea(`section_6.${index}.poOrDDue`, '', 'date', formik.values.section_6[index].poOrDDue)} </td>
                            <td style={{ ...cellStyleW, }}>  {renderTextAreaFull(`section_6.${index}.vPSComments`, '', formik.values.section_6[index].vPSComments)} </td>
                          </tr>) : (
                            <tr>

                              <td style={{ ...cellStyle }} > {item.selection} </td>
                              <td style={{ ...dropdownCellStyle, width: "100px", height: '40px', }}>  {renderSelect(`section_6.${index}.completed`, formik.values.section_6[index].completed)} </td>
                              <td style={{ ...cellStyleW, }}>  {renderTextAreaFull(`section_6.${index}.interiorDesignerComments`, '', formik.values.section_6[index].interiorDesignerComments)} </td>
                              <td style={{ ...dropdownCellStyle, width: "100px", height: '40px', }}>  {renderSelect(`section_6.${index}.idBidReq`, formik.values.section_6[index].idBidReq)} </td>
                              <td style={{ ...dropdownCellStyle, width: "100px", height: '40px', }}> {renderSelect(`section_6.${index}.pO`, formik.values.section_6[index].pO)} </td>
                              <td style={{ ...cellStyleW, }}> {renderInputArea(`section_6.${index}.poOrDDue`, '', 'date', formik.values.section_6[index].poOrDDue)} </td>
                              <td style={{ ...cellStyleW, }}>  {renderTextAreaFull(`section_6.${index}.vPSComments`, ' ', formik.values.section_6[index].vPSComments)} </td>
                            </tr>
                          )
                        )
                      })

                      }
                      {/* SCHEDULES  INTERIOR  End */}


                      {/* DRAWINGS  EXTERIOR  Start */}
                      {/* DRAWINGS  EXTERIOR  End - Section removed (not applicable) */}

                      {/* DRAWINGS  INTERIOR  start */}
                      {InteriorDesignTemplate.getFormName().section_8.map((item, index) => {
                        return (
                          index == 0 ? (<tr>
                            <td style={{ ...cellStyle, textAlign: 'center', fontWeight: '600' }} rowSpan={12}> Drawings</td>
                            <td style={{ ...cellStyle }} rowSpan={12} > INTERIOR  </td>
                            <td style={{ ...cellStyle }} > {item.selection} </td>
                            <td style={{ ...dropdownCellStyle, width: "100px", height: '40px', }}>  {renderSelect(`section_8.${index}.completed`, formik.values.section_8[index].completed)} </td>
                            <td style={{ ...cellStyleW, }}>  {renderTextAreaFull(`section_8.${index}.interiorDesignerComments`, ' ', formik.values.section_8[index].interiorDesignerComments)} </td>
                            <td style={{ ...dropdownCellStyle, width: "100px", height: '40px', }}>  {renderSelect(`section_8.${index}.idBidReq`, formik.values.section_8[index].idBidReq)} </td>
                            <td style={{ ...dropdownCellStyle, width: "100px", height: '40px', }}> {renderSelect(`section_8.${index}.pO`, formik.values.section_8[index].pO)} </td>
                            <td style={{ ...cellStyleW, }}> {renderInputArea(`section_8.${index}.poOrDDue`, '', 'date', formik.values.section_8[index].poOrDDue)} </td>
                            <td style={{ ...cellStyleW, }}>  {renderTextAreaFull(`section_8.${index}.vPSComments`, ' ', formik.values.section_8[index].vPSComments)} </td>
                          </tr>) : (
                            <tr>

                              <td style={{ ...cellStyle }} > {item.selection} </td>
                              <td style={{ ...dropdownCellStyle, width: "100px", height: '40px', }}>  {renderSelect(`section_8.${index}.completed`, formik.values.section_8[index].completed)} </td>
                              <td style={{ ...cellStyleW, }}>  {renderTextAreaFull(`section_8.${index}.interiorDesignerComments`, ' ', formik.values.section_8[index].interiorDesignerComments)} </td>
                              <td style={{ ...dropdownCellStyle, width: "100px", height: '40px', }}>  {renderSelect(`section_8.${index}.idBidReq`, formik.values.section_8[index].idBidReq)} </td>
                              <td style={{ ...dropdownCellStyle, width: "100px", height: '40px', }}> {renderSelect(`section_8.${index}.pO`, formik.values.section_8[index].pO)} </td>
                              <td style={{ ...cellStyleW, }}> {renderInputArea(`section_8.${index}.poOrDDue`, '', 'date', formik.values.section_8[index].poOrDDue)} </td>
                              <td style={{ ...cellStyleW, }}>  {renderTextAreaFull(`section_8.${index}.vPSComments`, ' ', formik.values.section_8[index].vPSComments)} </td>
                            </tr>
                          )
                        )
                      })

                      }
                      {/* DRAWINGS  INTERIOR  End */}

                      {InteriorDesignTemplate.getFormName().section_9.map((item, index) => {
                        return (
                          index == 0 ? (<tr>
                            <td style={{ ...cellStyle, textAlign: 'center', fontWeight: '600' }} rowSpan={6}> Site Inspections Complete</td>
                            <td style={{ ...cellStyle }} rowSpan={6} >  </td>
                            <td style={{ ...cellStyle }} > {item.selection} </td>
                            <td style={{ ...dropdownCellStyle, width: "100px", height: '40px', }}>  {renderSelect(`section_9.${index}.completed`, formik.values.section_9[index].completed)} </td>
                            <td style={{ ...cellStyleW, }}>  {renderTextAreaFull(`section_9.${index}.interiorDesignerComments`, ' ', formik.values.section_9[index].interiorDesignerComments)} </td>
                            <td style={{ ...dropdownCellStyle, width: "100px", height: '40px', }}>  {renderSelect(`section_9.${index}.idBidReq`, formik.values.section_9[index].idBidReq)} </td>
                            <td style={{ ...dropdownCellStyle, width: "100px", height: '40px', }}> {renderSelect(`section_9.${index}.pO`, formik.values.section_9[index].pO)} </td>
                            <td style={{ ...cellStyleW, }}> {renderInputArea(`section_9.${index}.poOrDDue`, '', 'date', formik.values.section_9[index].poOrDDue)} </td>
                            <td style={{ ...cellStyleW, }}>  {renderTextAreaFull(`section_9.${index}.vPSComments`, ' ', formik.values.section_9[index].vPSComments)} </td>
                          </tr>) : (
                            <tr>

                              <td style={{ ...cellStyle }} > {item.selection} </td>
                              <td style={{ ...dropdownCellStyle, width: "100px", height: '40px', }}>  {renderSelect(`section_9.${index}.completed`, formik.values.section_9[index].completed)} </td>
                              <td style={{ ...cellStyleW, }}>  {renderTextAreaFull(`section_9.${index}.interiorDesignerComments`, ' ', formik.values.section_9[index].interiorDesignerComments)} </td>
                              <td style={{ ...dropdownCellStyle, width: "100px", height: '40px', }}>  {renderSelect(`section_9.${index}.idBidReq`, formik.values.section_9[index].idBidReq)} </td>
                              <td style={{ ...dropdownCellStyle, width: "100px", height: '40px', }}> {renderSelect(`section_9.${index}.pO`, formik.values.section_9[index].pO)} </td>
                              <td style={{ ...cellStyleW, }}> {renderInputArea(`section_9.${index}.poOrDDue`, '', 'date', formik.values.section_9[index].poOrDDue)} </td>
                              <td style={{ ...cellStyleW, }}>  {renderTextAreaFull(`section_9.${index}.vPSComments`, ' ', formik.values.section_9[index].vPSComments)} </td>
                            </tr>
                          )
                        )
                      })

                      }
                      <tr>
                        <td>Risk/Safety/Client/Team/Other?</td>
                        <td style={{ ...cellStyleW, }} colSpan={8}>  {renderTextAreaFull('riskSafety', '')} </td>
                      </tr>
                    </tbody>
                  </table>

                </div>

              </AccordionTab>

              <AccordionTab header="GENERAL PROJECT CHECK LIST" className="mt-2">
                <div className="table-container" style={{ overflowX: "auto" }}>
                  <table style={{ borderCollapse: "collapse" }}>
                    <thead style={{ overflowX: "auto" }}>
                      <tr>
                        <th style={{ ...headerStyle, }} colSpan={4}>
                          General projects checklist:
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {preConstructionShedule.map((item, index) => {
                        return (
                          <tr key={index}>
                              <td style={{ ...cellStyleW, width: "300px", }}>
                                {renderInputArea('section_10.' + index + '.genrealProjectCheckListTitle', '', '', formik.values.section_10[index].genrealProjectCheckListTitle)}
                              </td>
                              <td style={{ ...dropdownCellStyle, width: "100px", height: '40px', }}>
                                {renderSelect('section_10.' + index + '.misc1', formik.values.section_10[index].misc1)}
                              </td>
                              <td style={{ ...cellStyleW, width: '70vw' }}>
                                {renderTextAreaFull('section_10.' + index + '.miscReason', '', formik.values.section_10[index].miscReason)}
                              </td>
                              <td style={{ ...cellStyleW, minWidth: "100px" }}>
                                {index > 0 ? (<FaTrash className='delete-buttonXX' onClick={() => handleDeleteInputForreConstructionShedule(index)} />) : null}

                                {preConstructionShedule.length - 1 == index ? (<FaPlus className='add-buttonXX' onClick={() => handleAddInputForPreConstructionShedule()} />) : null}
                              </td>
                          </tr>

                        )
                      })}
                    </tbody>
                  </table>
                </div>
              </AccordionTab>

            </Accordion>
              </div>
            </div>
        </form>
      )}
    </div>
  );
};

export default EDIT_INTERIOR_DESIGN_TEMPLATE